import router from '../../router/index.js';
import axios from "axios";

export default {
    authenticated: false,
    user:'',
    role:'',
    login(context, creds, redirect) {
        axios({ method: "POST", "url": "Auth/login", data: creds }).then(result => {
            if(result.data.code == '00') {
                this.authenticated = false
                this.userdata = result.data.detail
                alert('login failed , invalid username or password');
                // window.location.reload()
            }else{
                var datalog = result.data;
                window.localStorage.setItem('id_user',datalog.detail.id_user);
                window.localStorage.setItem('user_fullname',datalog.detail.name)
                window.localStorage.setItem('id_level',datalog.detail.id_level);
                window.localStorage.setItem('is_price',datalog.detail.is_price);
                window.localStorage.setItem('token', JSON.stringify(result.data.detail));
                this.authenticated = true;
                console.log(this.authenticated);
                alert('success login , click ok to be redirected to dashboard')
                window.location.reload()
            }
        }, error => {
            context.errors = errors;
        });
    },
    checkAuth: function() {
        if(window.localStorage.getItem('token')) {
            return true;
        } else {
            return false;
        }
    },
    logout: function() {
        window.localStorage.removeItem('app');
        window.localStorage.removeItem('id_user');
        window.localStorage.removeItem('id_level');
        window.localStorage.removeItem('token');
        this.authenticated = false;
        window.location.reload()
        router.push('/')
        // window.location.reload();
    }
}



// WEBPACK FOOTER //
// ./src/components/auth/Auth.js